// Copyright: IQGeo Limited 2010-2019
import L from 'leaflet';
global.L = L; //make L available as global
import myw from 'myWorld-base';
import '../style/sass/myWorld.scss';
import 'myWorld/base/application';
import 'myWorld/base/featureNavigation';

//datasources (each requires layer classes they can use)
import 'myWorld/datasources/datasources';

//controls
import 'myWorld/controls/mapControl';
import 'myWorld/controls/geoMapControl';
import 'myWorld/controls/loginDialog';
import 'myWorld/controls/search/searchControl';
import 'myWorld/controls/tabControl';
import 'myWorld/controls/detailsControl';
import 'myWorld/controls/feature/featureBriefControl';
import 'myWorld/controls/layers/layersControl';
import 'myWorld/controls/toolbarControl';
import 'myWorld/controls/notificationsControl/notificationsControl';
import 'myWorld/controls/resultsGridControl';
import 'myWorld/controls/printOptionsControl';
import 'myWorld/controls/stylePicker';
import 'myWorld/controls/phoneMenuControl';
import 'myWorld/controls/helpPanel';

//layouts
import 'myWorld/layouts/desktopLayout';
import 'myWorld/layouts/phone/phoneLayout';
import 'myWorld/layouts/phone/phoneLayoutDetailsPage';
import 'myWorld/layouts/printLayout';

//Plugins
import 'myWorld/plugins/bookmarkPlugin/bookmarkPlugin';
import 'myWorld/plugins/usageMonitorPlugin/usageMonitorPlugin';
import 'myWorld/plugins/createFeature';
import 'myWorld/plugins/directions';
import 'myWorld/plugins/exportFeatures';
import 'myWorld/plugins/internalsPlugin';
import 'myWorld/plugins/internetStatus';
import 'myWorld/plugins/magnifyingGlass';
import 'myWorld/plugins/mapLink';
import 'myWorld/plugins/measureTool';
import 'myWorld/plugins/minimap';
import 'myWorld/plugins/mousePositionControl';
import 'myWorld/plugins/notes';
import 'myWorld/plugins/mapViewStack';
import 'myWorld/plugins/print';
import 'myWorld/plugins/streetview';
import 'myWorld/plugins/userLocation';
import 'myWorld/plugins/zoomLevelControl';
import 'myWorld/plugins/adminNotifications';
import 'myWorld/plugins/tracePlugin/tracePlugin';
import 'myWorld/plugins/snappingPlugin';
import 'myWorld/plugins/softKeyboardInputPlugin';

import 'myWorld/uiComponents/index';

import 'myWorld/base/leafletIcon';
//optional third party components
import 'L.Control.Zoomslider';

const touchParam = myw.Util.getUrlParam('touchscreen');

/**
 * Whether the current browser is on a mobile device or not
 * @type {boolean}
 */
myw.isTouchDevice =
    touchParam && ['false', 'true'].includes(touchParam)
        ? touchParam == 'true'
        : L.Browser.mobile || !!navigator.maxTouchPoints; //The maxTouchPoints test covers IE/Edge browsers on windows tablets

//override L.Browser.touch to be the same as myw.isTouchDevice
L.Browser.touch = myw.isTouchDevice;

export default myw;
